'use strict';
import * as $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002finput$002finput$002ejs from "@awesome.me/webawesome/dist/components/input/input.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dCommon$002dKeys$0024$002dInput$002dInput$002dType$0024 from "./io.github.nguyenyou.webawesome.laminar.-Common-Keys$-Input-Input-Type$.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent from "./io.github.nguyenyou.webawesome.laminar.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_Input$() {
  this.jN = null;
  this.jM = null;
  this.jO = false;
  this.jP = null;
  this.jQ = false;
  this.Ix = null;
  this.Iy = false;
  this.Iv = null;
  this.Iw = false;
  this.It = null;
  this.Iu = false;
  $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__(this, "wa-input");
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_Input$ as $c_Lio_github_nguyenyou_webawesome_laminar_Input$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_Input$.prototype = new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_Input$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_Input$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_Input$ as $h_Lio_github_nguyenyou_webawesome_laminar_Input$ };
$h_Lio_github_nguyenyou_webawesome_laminar_Input$.prototype = $p;
$p.Yf = (function() {
  if ((!this.Iy)) {
    this.Ix = $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dCommon$002dKeys$0024$002dInput$002dInput$002dType$0024.$m_Lio_github_nguyenyou_webawesome_laminar_CommonKeys$InputInputType$();
    this.Iy = true;
  }
  return this.Ix;
});
$p.CI = (function() {
  if ((!this.Iw)) {
    this.Iv = this.Yf();
    this.Iw = true;
  }
  return this.Iv;
});
$p.ju = (function() {
  if ((!this.Iu)) {
    this.It = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "placeholder", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Iu = true;
  }
  return this.It;
});
$p.cQ = (function() {
  return $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002finput$002finput$002ejs;
});
var $d_Lio_github_nguyenyou_webawesome_laminar_Input$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_Input$, "io.github.nguyenyou.webawesome.laminar.Input$", ({
  jR: 1,
  bp: 1,
  bo: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_Input$ as $d_Lio_github_nguyenyou_webawesome_laminar_Input$ };
var $n_Lio_github_nguyenyou_webawesome_laminar_Input$;
function $m_Lio_github_nguyenyou_webawesome_laminar_Input$() {
  if ((!$n_Lio_github_nguyenyou_webawesome_laminar_Input$)) {
    $n_Lio_github_nguyenyou_webawesome_laminar_Input$ = new $c_Lio_github_nguyenyou_webawesome_laminar_Input$();
  }
  return $n_Lio_github_nguyenyou_webawesome_laminar_Input$;
}
export { $m_Lio_github_nguyenyou_webawesome_laminar_Input$ as $m_Lio_github_nguyenyou_webawesome_laminar_Input$ };
